<template>
    <div class="block block-quote" :class="[
        block.testimonial
            ? (block.fullWidth ? 'col-12' : 'col-12 col-md-10 col-lg-8 mx-auto')
            : 'container-fluid',
        block.testimonial && 'block-quote--testimonial',
        block.testimonial && block.image && 'block-quote--testimonial-image',
        !block.testimonial && block.backgroundColor === 'themeColor' && 'text-themeColor'
    ]">
        <div class="row content-block-row">
            <div v-if="block.testimonial && !(!block.sectionHeading && block.fullWidth)" class="col-12"
                :class="block.fullWidth ? '' : 'col-lg-3'">
                <h2 class="section-heading" v-if="block.sectionHeading">{{ block.sectionHeading }}</h2>
            </div>
            <div class="text-center" :class="block.testimonial
                ? ''
                : (block.fullWidth || false ? 'col-12 col-lg-9' : 'col-12 col-md-10 col-lg-10 mx-auto')">
                <blockquote v-html="block.text"></blockquote>
                <p v-if="block.author" class="quote-author">{{ block.author }}</p>

            </div>
        </div>
        <div v-if="block.testimonial && block.image" class="quote-image-wrapper">
            <img :src="block.image.src" :alt="block.image.title" :width="block.image.width" :height="block.image.height" class="quote-image">
        </div>
    </div>
</template>
<script>
export default {
    name: 'text',
    props: {
        block: Object,
        themeColor: {
            type: String,
            default: 'default',
        },
    },
};
</script>